import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

instance.defaults.headers.common['X-UIC-DEVICE'] = 'web'
instance.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`
instance.defaults.headers.common['X-UIC-VERSION'] = '1.0.0'
instance.defaults.headers.common['X-API-VERSION'] = '1.1.0'
instance.defaults.headers.common['X-UIC-DEVICE'] = 'browser'
instance.defaults.headers.common['X-UIC-PLATFORM'] = 'web'
instance.defaults.headers.get['Accepts'] = 'application/json'

const reqInterceptor = instance.interceptors.request.use(config => {
  console.log('Request Interceptor', config)
  return config
})
const resInterceptor = instance.interceptors.response.use(res => {
  console.log('Response Interceptor', res)
  return res
})

// instance.interceptors.request.eject(reqInterceptor)
// instance.interceptors.response.eject(resInterceptor)

export default instance